<div class="af-company-relation-container"
     *ngIf="dataItems().length > 1"
     [style.width.px]="controlWidth()">

  <span *ngIf="heading()" [ngClass]="headingCssClass()">{{heading()}}</span>

  <kendo-dropdownlist [data]="filteredDataItems()"
                      [loading]="loading()"
                      [value]="selectedItem()"
                      [filterable]="true"
                      textField="name"
                      valueField="id"
                      [valuePrimitive]="false"
                      class="company-relation-dl"
                      (valueChange)="onValueChange($event)"
                      (selectionChange)="onSelectionChange($event)"
                      (filterChange)="onFilterChange($event)">
    <ng-template kendoDropDownListItemTemplate let-dataItem>
      <ng-container >
        <span >{{ dataItem.name }}</span>
      </ng-container>
    </ng-template>

  </kendo-dropdownlist>
</div>
